import { combineReducers } from "redux";

import { travelAgentRegistrationDetails } from "./reducer.travelagentregistration"
const travelAgentsRegistrationDetailsReducers = combineReducers({

  travelAgentRegistrationDetails

})
export default travelAgentsRegistrationDetailsReducers;
